import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RecommendationCard = ({ 
  recommendation, 
  isSelected, 
  onSelect, 
  onViewDetails 
}) => {
  const getVariantStyles = () => {
    const baseStyles = "relative overflow-hidden transition-all duration-250";
    
    switch (recommendation?.variant) {
      case 'aggressive':
        return `${baseStyles} ${isSelected ? 'ring-4 ring-success/30 shadow-xl' : 'hover:shadow-lg'}`;
      case 'controlled':
        return `${baseStyles} ${isSelected ? 'ring-4 ring-primary/30 shadow-xl' : 'hover:shadow-lg'}`;
      case 'hold':
        return `${baseStyles} ${isSelected ? 'ring-4 ring-warning/30 shadow-xl' : 'hover:shadow-lg'}`;
      case 'restructure':
        return `${baseStyles} ${isSelected ? 'ring-4 ring-destructive/30 shadow-xl' : 'hover:shadow-lg'}`;
      default:
        return baseStyles;
    }
  };

  const getIconColor = () => {
    switch (recommendation?.variant) {
      case 'aggressive':
        return 'var(--color-success)';
      case 'controlled':
        return 'var(--color-primary)';
      case 'hold':
        return 'var(--color-warning)';
      case 'restructure':
        return 'var(--color-destructive)';
      default:
        return 'var(--color-foreground)';
    }
  };

  const getRiskBadgeColor = () => {
    switch (recommendation?.riskLevel) {
      case 'Rendah':
        return 'bg-success/10 text-success';
      case 'Sedang':
        return 'bg-warning/10 text-warning';
      case 'Tinggi':
        return 'bg-destructive/10 text-destructive';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  return (
    <div className={`card ${getVariantStyles()}`}>
      {isSelected && (
        <div className="absolute top-4 right-4 z-10">
          <div className="w-8 h-8 rounded-full bg-success flex items-center justify-center">
            <Icon name="Check" size={20} color="white" />
          </div>
        </div>
      )}
      <div className="flex items-start gap-4 mb-6">
        <div 
          className="w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0"
          style={{ backgroundColor: `${getIconColor()}15` }}
        >
          <Icon name={recommendation?.icon} size={28} color={getIconColor()} />
        </div>
        
        <div className="flex-1 min-w-0">
          <h3 className="text-xl font-semibold mb-2">{recommendation?.title}</h3>
          <p className="text-sm text-muted-foreground line-clamp-2">
            {recommendation?.description}
          </p>
        </div>
      </div>
      <div className="space-y-4 mb-6">
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">Tingkat Risiko</span>
          <span className={`px-3 py-1 rounded-full text-xs font-medium ${getRiskBadgeColor()}`}>
            {recommendation?.riskLevel}
          </span>
        </div>

        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">Investasi Diperlukan</span>
          <span className="text-sm font-semibold data-text">
            {recommendation?.investmentRequired}
          </span>
        </div>

        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">Timeline Implementasi</span>
          <span className="text-sm font-medium">{recommendation?.timeline}</span>
        </div>

        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">Confidence Score</span>
          <div className="flex items-center gap-2">
            <div className="w-24 h-2 bg-muted rounded-full overflow-hidden">
              <div 
                className="h-full bg-primary transition-all duration-500"
                style={{ width: `${recommendation?.confidenceScore}%` }}
              />
            </div>
            <span className="text-sm font-semibold data-text">
              {recommendation?.confidenceScore}%
            </span>
          </div>
        </div>
      </div>
      <div className="border-t border-border pt-4 mb-6">
        <h4 className="text-sm font-semibold mb-3">Hasil yang Diharapkan</h4>
        <ul className="space-y-2">
          {recommendation?.expectedOutcomes?.map((outcome, index) => (
            <li key={index} className="flex items-start gap-2 text-sm">
              <Icon name="CheckCircle2" size={16} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
              <span className="text-muted-foreground">{outcome}</span>
            </li>
          ))}
        </ul>
      </div>
      <div className="flex gap-3">
        <Button
          variant={isSelected ? "default" : "outline"}
          fullWidth
          onClick={() => onSelect(recommendation?.id)}
          iconName={isSelected ? "Check" : "Target"}
          iconPosition="left"
        >
          {isSelected ? 'Terpilih' : 'Pilih Rekomendasi'}
        </Button>
        
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onViewDetails(recommendation?.id)}
        >
          <Icon name="Info" size={20} />
        </Button>
      </div>
    </div>
  );
};

export default RecommendationCard;